import type { BanDich } from '../types';
import type { viBanGiao } from './ban-giao.vi';

/** Bản tiếng Anh của `ban-giao.vi.ts` (ADR-0092, ADR-0107). */
export const enBanGiao: Pick<BanDich, keyof typeof viBanGiao> = {
  banGiao: {
    tabBoCai: 'Installers',

    kenh: {
      STABLE: 'STABLE',
      BETA: 'BETA',
    },
    trangThaiPhatHanh: {
      PROCESSING: 'Processing',
      FAILED: 'Publish failed',
    },
    kieu: {
      INSTALL: 'New install',
      UPGRADE: 'Upgrade',
    },
    trangThai: {
      PREPARED: 'Prepared',
      DELIVERED: 'Delivered, awaiting customer',
      CUSTOMER_CONFIRMED: 'Confirmed by customer',
      FAILED: 'Failed',
      CANCELLED: 'Cancelled',
    },
    ketQua: {
      SUCCESS: 'Succeeded',
      ROLLED_BACK: 'Rolled back',
      FAILED: 'Failed',
    },
    topology: {
      K3S_SINGLE_NODE: 'K3s single node',
      COMPOSE_MINIMAL: 'Minimal Compose',
    },

    locTatCa: 'All channels',
    phatHanhMoi: 'Publish new release',
    boCaiCaption: 'On-premise installer releases',
    boCaiRong: 'No releases yet',
    boCaiRongMo: 'CI writes each finished build to the staging area; publish it from there to put it in the BETA channel.',
    boCaiRongLoc: 'No releases in this channel',
    cotPhienBan: 'Version',
    cotPhatHanh: 'Published',
    dongKenh: 'Channel',
    dongDungLuong: 'Size',
    xemChiTiet: 'View details',
    taoVeTaiBoCai: 'Create installer download link',
    duaLenStable: 'Promote to STABLE',
    thuHoiBan: 'Yank release',

    chiTietTieuDe: 'Release {{version}}',
    dongTepBoCai: 'Installer file',
    dongSha: 'Installer SHA-256',
    chuaRoDungLuong: 'Unknown',
    dongNenTang: 'Platforms',
    dongTopology: 'Deployment topologies',
    dongNangTu: 'Direct upgrade from',
    khongGioiHanNangTu: 'Any version',
    dongKeyring: 'Keyring sequence',
    dongPhatHanhLuc: 'Published at',
    dongManifest: 'Manifest (JWS)',
    chepManifest: 'Copy manifest',
    thanhPhanTieuDe: 'Components',
    thanhPhanCaption: 'Images in installer {{version}}, pinned by digest',
    thanhPhanRong: 'The manifest lists no components',
    cotThanhPhan: 'Component',
    cotImage: 'Image and digest',

    phatHanhTieuDe: 'Publish a new installer',
    phatHanhMo:
      'CI has written the installer and release.json to the staging area platform/installers/incoming/. The system works in the background: it moves the file to the official store, hashes it with SHA-256, signs the manifest and adds the release to the BETA channel. A multi-GB installer takes a few minutes; you can close this dialog. The file never passes through your browser.',
    oThuMuc: 'Staging folder',
    oThuMucGoiY: 'The folder name CI printed at the end of the build, in the form <product_code>-<version>.',
    oThuMucViDu: 'platform-enterprise-2.5.0',
    nhanPhatHanh: 'Publish to BETA',
    dangPhatHanh: 'Publishing...',
    loiThieuThuMuc: 'Enter the folder name CI printed.',
    loiThuMucSai:
      'Folder names may contain only letters, digits, dots, underscores and hyphens, and cannot start with a dot or hyphen.',
    daPhatHanh: 'Received {{version}}. Processing in the background; the table updates when it finishes.',
    dangXuLyPhanTram: 'Processing {{phanTram}}%',
    phatHanhLai: 'Publish again',
    dongLyDoThatBai: 'Failure reason',
    coSauKhiXong: 'Available once publishing finishes',

    duaLenTieuDe: 'Promote {{version}} to STABLE?',
    duaLenThan:
      'STABLE releases can be handed over to customers. Promote only after internal testing is done. A release cannot be moved back to BETA.',
    nhanDuaLen: 'Promote {{version}} to STABLE',
    daDuaLenStable: 'Promoted {{version}} to STABLE.',

    thuHoiBanTieuDe: 'Yank release {{version}}?',
    thuHoiBanThan:
      'A yanked release disappears from the list and can no longer get download links or new handovers. Existing handovers stay as they are; the file and manifest are kept for audit. This cannot be undone.',
    lyDoThuHoiBan: 'Reason for yanking',
    lyDoThuHoiBanViDu: 'For example: a migration locks the audit table too long on large datasets.',
    loiThieuLyDoThuHoiBan: 'Enter a reason so others know why this release was pulled.',
    nhanThuHoiBan: 'Yank {{version}}',
    daThuHoiBan: 'Yanked {{version}}.',

    veBoCaiTieuDe: 'Download link for installer {{version}}',
    veBanGiaoTieuDe: 'Download link for handover kit {{version}}',
    veThan: 'This link works once and expires at {{luc}} (after 10 minutes). Create a new link if it expires or has been used.',
    veCanhBao: 'No sign-in is needed to download: anyone with the link can use it, so send it only to the intended recipient.',
    moLienKet: 'Download',
    chepLienKet: 'Copy download link',
    saoChep: 'Copy',
    daChep: 'Copied',
    khongChepDuoc: 'Your browser blocked automatic copying. Select the text and copy it manually.',

    lichSuTieuDe: 'Handover history',
    lichSuMo: 'Handover kits prepared for this tenant and the results the customer sent back',
    lichSuCaption: 'On-premise handover history for {{ten}}',
    lichSuRong: 'Nothing handed over yet',
    lichSuRongMo: 'Create a handover from a STABLE release to get a handover kit and handover sheet for the customer.',
    cotNgayTao: 'Created',
    dongLoai: 'Type',
    chuaGanCaiDat: 'No installation yet',
    theoXacNhan: 'Per customer confirmation on {{ngay}}',
    theoBaoCaoThatBai: 'Per customer report on {{ngay}}',
    xemPhieu: 'View handover sheet',
    taiBoBanGiao: 'Create handover kit download link',
    danhDauDaGiao: 'Mark as delivered',
    ghiKetQua: 'Record upgrade result',
    huyBanGiao: 'Cancel handover',

    taoBanGiao: 'Create handover',
    taoBanGiaoNangCap: 'Create upgrade handover',
    taoTieuDe: 'Create on-premise handover',
    taoMo: 'The system builds a handover kit for this tenant (trust store, sample configuration, guides). The kit contains no license and no secrets.',
    kieuInstallMo:
      'First-time install. Moves to "Confirmed by customer" automatically when a matching activation-request.json arrives.',
    kieuUpgradeMo: 'Upgrade a running installation. Confirmed with the upgrade-report.json the customer sends back.',
    chonCaiDat: 'Choose the installation to upgrade',
    nhanCaiDat: '{{ten}} · running {{version}}',
    chuaCoCaiDat:
      'This tenant has no installation that can take a handover. Installations appear once the customer sends activation-request.json.',
    chuaRoDangChay:
      'The running version of this installation is unknown. You can still create the handover; foxai-install upgrade checks the version on the customer machine.',
    oBanPhatHanh: 'Release',
    chonBan: 'Choose a STABLE release',
    nhanBan: '{{version}} · {{san_pham}} · {{ngay}}',
    dangTaiBan: 'Loading releases...',
    chiStable: 'Only STABLE releases that have not been yanked can be handed over.',
    chuaCoStable: 'No STABLE release yet. Promote a tested BETA release on the Installers tab of the License screen.',
    khongCoBanNangCap: 'No STABLE release is newer than the running version and can upgrade directly from it.',
    ghiChuTaoGoiY: 'Optional. For example: contract number, expected recipient.',
    loiChuaChonCaiDat: 'Choose the installation to upgrade.',
    loiChuaChonBan: 'Choose a STABLE release.',
    dangTao: 'Creating...',
    daTao: 'Created handover for {{version}}.',

    phieuDialogTieuDe: 'Handover sheet for {{version}}',
    dongShaBoBanGiao: 'Handover kit SHA-256',
    dongBangChung: 'Evidence SHA-256',
    dongGhiChu: 'Note',
    dongTaoLuc: 'Created at',

    giaoTieuDe: 'Mark the {{version}} handover as delivered?',
    giaoThan: 'Records that the handover kit reached the customer. The handover moves to "Delivered, awaiting customer".',
    oKenhGiao: 'Delivery channel and recipient',
    oKenhGiaoGoiY: 'Optional. For example: link emailed to Mr. Huy, IT department.',
    daDanhDauGiao: 'Marked as delivered.',

    ghiTieuDe: 'Record result of upgrade to {{version}}',
    ghiThan:
      'Upload the upgrade-report.json that foxai-install upgrade wrote on the customer machine. The report is not signed: the system records it as the customer’s confirmation, not as proof of a successful install.',
    tepBaoCao: 'upgrade-report.json file',
    baoCaoKeoTha: 'Drop upgrade-report.json here, or click to choose a file',
    baoCaoKeoThaMo: 'JSON file, up to 64 KB.',
    dongKetQua: 'Result',
    dongNangCap: 'Upgrade',
    tuDen: '{{tu}} → {{den}}',
    dongXongLuc: 'Finished at',
    ghiHauQuaThanhCong:
      'The handover will move to "Confirmed by customer" and the installation will count as running this version.',
    ghiHauQuaThatBai: 'The handover will move to "Failed". This is final: to deliver again, create a new handover.',
    ghiChuGoiY: 'Optional. For example: who sent the report and how.',
    dangGhi: 'Recording...',
    loiBaoCaoJson: 'This file is not valid JSON. Choose the upgrade-report.json produced by foxai-install.',
    loiBaoCaoDoiTuong: 'The file must be a JSON object. Choose the upgrade-report.json produced by foxai-install.',
    loiBaoCaoThieu: 'The report is missing {{truong}}. Choose the upgrade-report.json produced by foxai-install.',
    loiBaoCaoKetQua: 'result must be SUCCESS, ROLLED_BACK or FAILED. Check the file the customer sent.',
    loiBaoCaoLech:
      'The report’s {{truong}} does not match this handover. The customer may have sent the report of another upgrade; ask them again.',
    loiBaoCaoLon: 'The file is larger than 64 KB, so it is not an upgrade-report.json. Choose another file.',
    loiBaoCaoChuaChon: 'Choose an upgrade-report.json file to continue.',
    daGhiThanhCong: 'Recorded: the customer confirmed the upgrade to {{version}}.',
    daGhiThatBai: 'Recorded: the upgrade to {{version}} failed. Create a new handover when ready to deliver again.',

    huyTieuDe: 'Cancel the {{version}} handover?',
    huyThan:
      'The handover moves to "Cancelled" and can no longer be delivered or have a result recorded. A kit already sent does not stop working on its own: tell the customer not to use it. This cannot be undone.',
    lyDoHuy: 'Reason for cancelling',
    lyDoHuyViDu: 'For example: the release was yanked before delivery.',
    loiThieuLyDoHuy: 'Enter a reason so others know why this handover stopped.',
    daHuy: 'Handover cancelled.',

    phieuTieuDe: 'Handover sheet',
    phieuKenhThuHai:
      'Send the values below through a second channel, separate from the file delivery: an email from the contract contact, or a printed copy. Never send them with the download link or inside the handover kit.',
    phieuSha: 'Installer {{version}} SHA-256',
    phieuVanTay: 'Root key fingerprint',
    phieuVanTaySo: 'Root key fingerprint {{so}}',
    phieuCachDoiChieu:
      'The customer administrator runs sha256sum on the installer and compares before extracting it; foxai-install verify prints the root key fingerprints for a second check.',
    chepSha: 'Copy installer SHA-256',
    chepVanTay: 'Copy root key fingerprint {{so}}',

    cotDangChay: 'Running version',
    chuaRo: 'Unknown',
    ngungDung: 'Decommission',
    ngungTieuDe: 'Decommission installation {{ten}}?',
    ngungThan:
      'The installation moves to "Decommissioned" and accepts no new license requests or handovers. Its licenses must be revoked first: the system refuses while a valid license remains. This cannot be undone.',
    lyDoNgung: 'Reason for decommissioning',
    lyDoNgungViDu: 'For example: the customer moved to a new server cluster in Thu Duc.',
    loiThieuLyDoNgung: 'Enter a reason for decommissioning this installation.',
    nhanNgung: 'Decommission installation',
    daNgungCaiDat: 'Decommissioned installation {{ten}}.',

    checklistTieuDe: 'Bring this on-premise tenant online',
    checklistMo: '{{xong}} of {{tong}} steps done',
    buocSo: 'Step {{so}}. {{ten}}',
    buoc1: 'Create a handover',
    buoc1Mo: 'Pick a STABLE release; the system builds the handover kit and handover sheet to send to the customer.',
    buoc2: 'Receive activation-request.json',
    buoc2Mo:
      'Once installed, the installer produces activation-request.json. This step is done when the first installation is registered.',
    buoc3: 'Issue a license',
    buoc3Mo: 'Load activation-request.json in the license wizard, then sign a license for that installation.',
    daXong: 'done',
    chuaXong: 'not done',
  },
};
